// Converts "yyyy-mm-dd" to "dd-mm-yyyy"
// export const formatDate = (dateString) => {
//   if (!dateString) return "";

//   try {
//     const date = new Date(dateString); // handles both date and datetime
//     if (isNaN(date)) return dateString; // fallback if invalid

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-based
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   } catch {
//     return dateString; // fallback
//   }
// };


// src/utils/formatDateByConfig.js
import useAppConfigStore from '../store/useAppConfigStore';

export const formatDate = (dateInput) => {
  if (!dateInput) return "";

  try {

    const datePattern = /^\d{4}-\d{2}-\d{2}|^\d{2}-\d{2}-\d{4}|^\d{2}\/\d{2}\/\d{4}/;
    if (!datePattern.test(dateInput)) return dateInput;

    const date = new Date(dateInput);
    if (isNaN(date)) return dateInput;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Get configuration from store
    const { dateFormat, dateSeparator } = useAppConfigStore.getState();

    // console.log("Date Format",dateFormat)
    // console.log("Date Sep",dateSeparator)

    let formatted = "";

    switch (dateFormat) {
      case "DD MM YYYY":
        formatted = [day, month, year].join(dateSeparator);
        break;
      case "YYYY MM DD":
        formatted = [year, month, day].join(dateSeparator);
        break;
      case "MM DD YYYY":
        formatted = [month, day, year].join(dateSeparator);
        break;
      default:
        formatted = [day, month, year].join(dateSeparator);
    }

    return formatted;
  } catch {
    return dateInput;
  }
};



// export const formatDateTime = (dateTimeString) => {
//   if (!dateTimeString) return "";

//   try {
//     const date = new Date(dateTimeString);
//     if (isNaN(date)) return dateTimeString;

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     let hours = date.getHours();
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     const ampm = hours >= 12 ? "PM" : "AM";
//     hours = hours % 12 || 12; // 0 => 12, 13 => 1

//     return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
//   } catch {
//     return dateTimeString;
//   }
// };


export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return "";

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date)) return dateTimeString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Get configuration from store
    const { dateFormat, dateSeparator } = useAppConfigStore.getState();

    let formattedDate = "";
    switch (dateFormat) {
      case "DD MM YYYY":
        formattedDate = [day, month, year].join(dateSeparator);
        break;
      case "YYYY MM DD":
        formattedDate = [year, month, day].join(dateSeparator);
        break;
      case "MM DD YYYY":
        formattedDate = [month, day, year].join(dateSeparator);
        break;
      default:
        formattedDate = [day, month, year].join(dateSeparator);
    }

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${formattedDate} ${hours}:${minutes} ${ampm}`;
  } catch {
    return dateTimeString;
  }
};

export const getThisWeekRange = () => {
  const today = new Date();
  const day = today.getDay();
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - day);
  const format = (d) => d.toISOString().split("T")[0];
  return {
    from: format(sunday),
    to: format(today),
  };
};

export const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

